import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=2970d9c8&scoped=true&"
import script from "./VerificationCode.vue?vue&type=script&lang=ts&"
export * from "./VerificationCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2970d9c8",
  null
  
)

export default component.exports